rdefine("ag/gallery",['backbone','text!ag/modal.html', 'ag/collections/smallGallery','text!ag/uploading.html','ag/editor'],function(Backbone,template,smallGallery,tupload,EditorModal) {

    var imageLi = Backbone.Ribs.View.extend({
        tagName:'li',
        bindings:{
            'el':{
                css: {
                    'background-image': {
                        data: 'model.url',
                        processor: function (url) {
                            return "url('"+url.replace("0x0","200x200")+"')";
                        }
                    }
                },
                attr:{
                    'data-id':'model.id'
                }
            },
            'input':{
                checked:"model.asdelete"
            }
        },
        events:{
            "change input":"onChangeSelect",
            "click":"onClickSelf"
        },
        initialize:function(){
            this.$el.append('<div class="checkbox">\n' +
                '                            <label>\n' +
                '                                <input type="checkbox">\n' +
                '                                <i class="input-helper"></i>\n' +
                '                            </label>\n' +
                '                        </div>');
            this.$el.fadeIn();
        },
        onChangeSelect:function(){
            setTimeout(function(){
                this.collection.trigger('displayDeleteChoice');
            }.bind(this),50);
        },
        onClickSelf:function(e) {
            if(e.target === this.el) {
                this.collection.trigger("openEditor",this.model);
            }
        }
    });

    var loadingLi = Backbone.Ribs.View.extend({
        tagName:'li',
        timeout:0,
        bindings:{
            '.name-label':{
                text:{
                    data:'model.name'
                }
            },
            '.progress-bar':{
                css:{
                    width:{
                        data:['model.loaded','model.total'],
                        processor:function(loaded,total) {
                            return total ? (Math.ceil(loaded/total*100) + "%") : "0%";
                        }
                    }
                }
            },
            '.loaded-of':{
                text:{
                    data:['model.loaded','model.total'],
                    processor:function(loaded,total) {
                        var aloaded = (loaded/1000000).toFixed(2);
                        var atotal = (total/1000000).toFixed(2);
                        return aloaded + "mb of " + atotal + "mb " + ( total ? Math.ceil(loaded/total*100) : 0) + "%";
                    }
                }
            }
        },
        initialize:function() {
            //image set
            var file = this.model.get("file");
            this.model.set({
                name:file.name,
                total:file.size,
                loaded:0
            });
            console.log(file);
            this.$el.html(Template7.compile(tupload)());
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                console.log("done");
                this.$el.find(".image-place")[0].style.backgroundImage="url('"+reader.result+"')";
            }.bind(this);
            reader.onerror = function (error) {
                this.collection.remove(this.model);
            }.bind(this);
            this.uploadFile(file);
        },
        uploadFile:function(file){
            var form_data = new FormData();
            form_data.append('image', file);
            form_data.append('group_id',this.collection.group_id);
            $.ajax({
                url: '/frontend/api/ajax-gallery', // point to server-side PHP script
                //dataType: 'text',  // what to expect back from the PHP script, if anything
                cache: false,
                contentType: false,
                processData: false,
                data: form_data,
                type: 'post',
                xhr: function() {
                    var xhr = new window.XMLHttpRequest();
                    xhr.upload.addEventListener("progress", function(evt) {
                        if (evt.lengthComputable) {
                            console.log(evt.total,evt.loaded);
                            this.model.set({
                                total:evt.total,
                                loaded:evt.loaded
                            });
                            //Do something with upload progress here
                        }
                    }.bind(this), false);

                    xhr.addEventListener("progress", function(evt) {
                        if (evt.lengthComputable) {
                            console.log(evt.total,evt.loaded);
                            this.model.set({
                                total:evt.total,
                                loaded:evt.loaded
                            });
                            //Do something with download progress
                        }
                    }.bind(this), false);

                    return xhr;
                }.bind(this),
                success: function(response){
                    console.log(response);
                    this.collection.trigger("uploaded",response);
                    this.collection.remove(this.model);
                }.bind(this),
                error: function(xhr, ajaxOptions, thrownError) {
                    this.collection.remove(this.model);
                    console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                }.bind(this)
            });
        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'modal fade',
        group_id: 0,
        col:null,
        bindings:{
            'ul.ajax-gallrey-images':{
                collection:{
                    col:'col',
                    view:imageLi
                },
                toggle:{
                    data:'model.small',
                    processor:function(a) { return a;}
                }
            },
            '.no-images':{
                toggle:{
                    data:'model.small',
                    processor:function(a) { return !a;}
                }
            },
            '.uploading-images':{
                toggle:{
                    data:'model.loading'
                },
                collection:{
                    col:'queue',
                    view:loadingLi
                }
            },
            '.ajax-gallery-drop-upload-zone span':{
                toggle:{
                    data:'model.loading',
                    processor:function(a){return !a;}
                }
            }
        },
        events:{
            "click .close-modal":"close",
            "click .set-upload-state":"setUploadState"
        },
        initialize:function(options) {
            $("body").append(this.el);
            this.tmsg = Template7.compile("{{lang \"ag.message-drop\"}}")();
            this.ttempl = Template7.compile("<div class='msg'><span>{{lang \"ag.message-drop\"}}</span><button class='btn btn-danger btn-sm'>{{lang \"ag.message-delete-button\"}}</button></div>");
            this.$del = $("<div class='ajax-gallery-float-delete'></div>").html(this.ttempl({}));
            this.$del.find("button").on("click",this.doDeleteSelected.bind(this));
            $("body").append(this.$del);
            this.model = new Backbone.Ribs.Model({small:0,loading:false,current:0,max:2});
            this.queue = new Backbone.Ribs.Collection([],{model:Backbone.Ribs.Model});
            this.queue.on("add reset remove", function(){
                this.model.set("loading",this.queue.length ? true : false);
            }.bind(this));
            this.group_id = options.group_id ? options.group_id : 0;
            this.queue.group_id = this.group_id;
            this.model.set("group_id",this.group_id);
            this.$el.html(Template7.compile(template)({group_id:this.group_id}));
            this.col = new smallGallery([],{group_id:this.group_id});
            this.col.on("add remove reset", function(){
                this.model.set("small",this.col.length);
                this.$el.find("ul.ajax-gallrey-images").sortable('refresh');
            }.bind(this));
            this.col.on("displayDeleteChoice",this.displayDeleteChoice.bind(this));
            this.col.loadAll();
            this.col.on("openEditor",this.openEditor.bind(this));
            this.$el.modal();
            this.$el.on("hidden.bs.modal",this.removeIt.bind(this));
            this.queue.on("uploaded",function(media) {
                this.col.add(media);
            }.bind(this));
            //load small gallery
            var img = '';
            var plc = $('<li class="placeholder"></li>');
            var adjustment = {} ;
            this.$el.find("ul.ajax-gallrey-images").sortable({
                containerSelector: 'ul.ajax-gallrey-images',
                itemSelector: 'li',
                onMousedown:function($item,_super,event) {
                    img = $item.css("background-image");
                    plc.css("background-image",img);
                    if(event.target!==$item[0]) {
                        return false;
                    }
                    return true;
                },
                onDragStart: function ($item, container, _super) {
                    var offset = $item.offset(),
                        pointer = container.rootGroup.pointer;
                    var a = this.$el.closest(".modal")[0];
                    console.log(offset);
                    adjustment = {
                        left: pointer.left - offset.left,
                        top: pointer.top - offset.top
                    };

                    _super($item, container);
                }.bind(this),
                onDrag: function ($item, position) {
                    $item.css({
                        left: position.left - adjustment.left,
                        top: position.top - adjustment.top
                    });
                },
                onDrop:function ($item, container, _super, event) {
                    $item.removeClass(container.group.options.draggedClass).removeAttr("style");
                    $item.css('background-image',img);
                    $("body").removeClass(container.group.options.bodyClass)
                    //rebuild ordering
                    var items = this.$el.find("ul.ajax-gallrey-images li");
                    var send = [];
                    for(var i =0;i<items.length;i++) {
                        var id = $(items[i]).attr("data-id");
                        send.push({id:id,order:i});
                        var m = this.col.get(+id);
                        m.set({order:i});
                    }
                    $.post("/frontend/api/ajax-gallery",{sorts:send});
                }.bind(this),
                placeholder:plc,
                pullPlaceholder:true,
                distance:10
               //s exclude:" >"

                //handle:'.drag-wrap span',
                //onDrop:this.rebuildOrdering.bind(this)
            });

            this.attachDrop();
        },
        attachDrop:function() {
            this.$el.find(".ajax-gallery-body")[0].addEventListener('dragover', this.handleDragOver.bind(this));
            this.$el.find(".ajax-gallery-body")[0].addEventListener('dragleave', this.handleDragLeave.bind(this));
            this.$el.find(".ajax-gallery-body")[0].addEventListener('drop', this.handleDrop.bind(this));

            this.$el.find("input[type=file]")[0].addEventListener('change', this.handleFileSelect.bind(this));
        },
        handleDragOver:function(e){
            e.preventDefault();
            this.$el.find(".ajax-gallery-body").addClass("handlefile");
        },
        handleDragLeave:function(e){
            e.preventDefault();
            this.$el.find(".ajax-gallery-body").removeClass("handlefile");
        },
        handleFileSelect:function(e) {
            this.addToUploadQueue(e.target.files);
            e.target.value = '';
        },
        handleDrop:function(e){
            e.preventDefault();
            this.$el.find(".ajax-gallery-body").removeClass("handlefile");
            this.addToUploadQueue(e.dataTransfer.items || e.dataTransfer.files);
        },
        show:function(){
            this.$el.modal('show');
        },
        close:function(){
            this.$el.modal('hide');

        },
        removeIt:function(){
            //this.$el.modal('dispose');
            if(this.done) {
                this.done();
            }
            this.$del.remove();
            this.$el.remove();
        },
        setUploadState:function(){
            this.model.set("loading",!this.model.get("loading"));
            return false;
        },
        addToUploadQueue:function(files) {
            console.log(files);
            for(var i =0; i<files.length;i++) {
                var item = files[i];
                if (item.getAsFile && item.kind =='file') {
                    this.queue.add({file: files[i].getAsFile()});
                }else{
                    this.queue.add({file: files[i]});
                }
            }
        },
        displayDeleteChoice:function() {
            var l = this.col.where({asdelete:true}).length;
            console.log(l);

            var l2 = this.col.length;
            this.$del.find("span").html(this.tmsg.replace(":p1",l).replace(":p2",l2));
            if(l) {
                this.$del.addClass("showing");
            }else{
                this.$del.removeClass("showing");
            }

        },
        doDeleteSelected:function(e) {
            e.preventDefault();
            var deletes = this.col.where({asdelete:true});
            var ids = deletes.map(function(i){ return i.id; });
            $.post("/frontend/api/ajax-gallery/0",{"_method":"delete","ids":ids},function(resp){
                SuccessMessage(resp.message);
            });
            this.$del.removeClass("showing");
            this.col.remove(deletes);
            console.log(ids);
            return false;
        },
        openEditor:function(model) {
            console.log(arguments);
            //model.set("url",model.get("url")+"?"+Date.now());
            this.$el.find(".modal-dialog").animate({"opacity":0});
            var modal = new EditorModal({model:model});
            modal.show();
            modal.done = function() {
                this.$el.find(".modal-dialog").animate({"opacity":1});
            }.bind(this);
        }
    });
});